import { forwardRef, type AnchorHTMLAttributes } from "react";
import { cn } from "../lib/cn";

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  /** always (default) → underline, hover → underline on hover, none → never. */
  underline?: "always" | "hover" | "none";
  /** primary = content-primary, secondary = content-secondary, inherit = no class. */
  color?: "primary" | "secondary" | "inherit";
}

const colorClass = {
  primary: "text-content-primary",
  secondary: "text-content-secondary",
  inherit: "",
} as const;

const underlineClass = {
  always: "underline",
  hover: "no-underline hover:underline",
  none: "no-underline",
} as const;

/** Native anchor only — router consumers compose their own anchor. */
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ underline = "always", color = "primary", className, ...props }, ref) => {
    return (
      <a
        ref={ref}
        className={cn(
          "cursor-pointer rounded-sm transition-colors outline-none hover:text-content-accent focus-visible:ring-2 focus-visible:ring-border-focused focus-visible:ring-offset-1 focus-visible:ring-offset-surface-canvas",
          colorClass[color],
          underlineClass[underline],
          className,
        )}
        {...props}
      />
    );
  },
);
Link.displayName = "Link";
